import { default as _u } from 'underscore';
import getConvertedAccountPeriodToComponentPeriod from '../resolvers/getConvertedAccountPeriodToComponentPeriod';

/**
 * This function is responsible for mutating single period on product's account change.
 * To reduce complexity of reducer and decouple specialized logic into separate function
 * any on-account-change specific mutations that impacts periods should be placed within
 * the current function (when it's applicable).
 *
 * @param {object} period
 * @param {object} accountPeriods
 */
export default (period, accountPeriods) => {
    const matchPeriod = _u.find(accountPeriods, (accountPeriod) => {
        return accountPeriod?.interval === period?.billing_period
            && accountPeriod?.interval_count === period?.interval;
    });

    if (matchPeriod) {
        // Convert account's period and apply it over regular period (non-account specific).
        const convertedMatchPeriod = getConvertedAccountPeriodToComponentPeriod(matchPeriod);
        for (const key in convertedMatchPeriod) {
            period[key] = convertedMatchPeriod[key];
        }
    }
}
